export default __webpack_public_path__ + "static/media/boy.c372a8fe.png";